<form [formGroup]="formGroup">
    <p-treeSelect
    #treeSelect
    [panelClass]="styleClass"
    [containerStyleClass]="styleClass"
    [options]="filteredOptions"
    placeholder="Select..."
    [selectionMode]="selectionMode"
    [filter]="true" 
    [filterInputAutoFocus]="true"
    formControlName="selectedTenants"
    (onNodeSelect)="onNodeSelect($event)"
    (onNodeUnselect)="onNodeUnselect($event)"
    [class]="'text-white'"
    appendTo="body">
    </p-treeSelect>
</form>